// The studio shell: sidebar, header, account (V4Layout).
export default {
  nav: {
    portfolio: 'Portfolio',
    radar: 'Radar',
    catalogue: 'Catalogue',
    zeus: 'Zeus',
    taches: 'My tasks',
    sonar: 'Explore',
    conversations: 'Conversations',
    channel: 'Dashboard',
    audits: 'Audit',
    drifts: 'Drifts',
    'wizard-dossier': 'Create your brand',
    monday: 'Monday brief',
    decisions: 'Research desk',
    'dossier-precog': 'PreCog',
    arena: 'Twins',
    calendar: 'Calendar',
    map: 'Cosmic map',
    config: 'Setup & collection',
    sentinel: 'Sentinel',
    discovery: 'Discovery',
    replica: 'Replica',
    'ent-formats': 'Formats',
    'ent-soirees': 'Evenings & register',
    'ent-diffuseurs': 'Broadcasters',
    'ent-pays': 'Export markets',
    'ent-brief': 'The brief',
    'polis-projection': 'Projections',
    'polis-electorat': 'Electorate',
    'polis-scenarios': 'Scenarios',
    'polis-candidats': 'Candidates',
    'polis-sonar': 'Sonar',
    'polis-registre': 'Register',
    'polis-scrutin': 'Election settings',
    'polis-personnalites': 'Public figures',
    'polis-suivis': 'Following',
    wizard: 'New brand',
    precog: 'PreCog',
    calibration: 'Calibration',
    equipe: 'Team',
  },
  groupe: {
    observer: 'Observe',
    interroger: 'Ask',
    dossier: 'Project',
    beta: 'Orion Beta',
    projector: 'Projector',
    polis: 'Polis',
    organisation: 'Organisation',
    configuration: 'Setup',
    administration: 'Administration',
  },
  dossier: {
    courant: 'The current project: everything you see relates to it',
    choisir: '- choose a project -',
    archive: '(archived)',
    aucun: 'no project',
    le: 'The project',
    mes: 'My projects',
  },
  projector: {
    dossier: 'Projector project',
    choisir: '- choose a project -',
    creer: '+ Create a format',
    format: 'Overview',
    sonar: 'Sonar',
    documents: 'Documents',
    ecoute: 'Listening',
    suivi: 'On air',
  },
  polis: {
    election: 'The Polis election',
    choisir: '- choose an election -',
    nouvelle: '+ New election',
    enPreparation: '(being prepared)',
  },
  aucunModule: {
    titre: 'No module granted',
    texte: 'Your organisation’s administrator grants them from the Team page.',
  },
  donneesAJour: 'Data up to date',
  organisation: 'Organisation',
  seDeconnecter: 'Sign out',
  sortir: 'Sign out',
  theme: 'Toggle dark / light',
  langue: 'Language',
  nouvelleVersion: 'A new version of Orion is available.',
  recharger: 'Reload',
}
